import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ModalEvent } from '../interfaces/modal-event';

@Injectable({
  providedIn: 'root',
})
export class LynxModalService {
  private toggleSubject = new Subject<ModalEvent>();
  private isLoading = new BehaviorSubject<boolean>(false);
  private isSolidModalBg = new BehaviorSubject<boolean>(false);

  public dispatch(modalEvent: ModalEvent): void {
    this.toggleSubject.next(modalEvent);
  }

  public activateSolidModalBg(): void {
    this.isSolidModalBg.next(true);
  }

  public deactivateSolidModalBg(): void {
    this.isSolidModalBg.next(false);
  }

  public showLoading(): void {
    this.isLoading.next(true);
  }

  public hideLoading(): void {
    this.isLoading.next(false);
  }

  get toggle$(): Observable<ModalEvent> {
    return this.toggleSubject.asObservable();
  }

  get isLoading$(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  get isSolidModalBg$(): Observable<boolean> {
    return this.isSolidModalBg.asObservable();
  }
}
